import { render, staticRenderFns } from "./roleOpen.vue?vue&type=template&id=b4c8e41c&scoped=true&"
import script from "./roleOpen.vue?vue&type=script&lang=js&"
export * from "./roleOpen.vue?vue&type=script&lang=js&"
import style0 from "./roleOpen.vue?vue&type=style&index=0&id=b4c8e41c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c8e41c",
  null
  
)

export default component.exports